import React from 'react';
import { useT } from '../i18n';
interface SlideHookProps {
  onStart: () => void;
}
export function SlideHook({
  onStart
}: SlideHookProps) {
  const {
    t
  } = useT();
  return <div className="flex flex-col h-full w-full justify-center items-center animate-fade-in-up" data-id="element-222">
      <div className="mb-10 text-center" data-id="element-223">
        <div className="text-solventum-primary text-sm font-body uppercase tracking-widest mb-6" data-id="element-224">
          Solventum
        </div>

        {/* Big 18 visual */}
        <div className="relative inline-flex items-center justify-center mb-6" data-id="element-225">
          <div className="absolute w-24 h-24 rounded-full bg-solventum-primary/10 animate-pulse" data-id="element-226" />
          <span className="relative text-6xl font-headline font-extrabold text-solventum-primary" data-id="element-227">
            18
          </span>
        </div>

        <h1 className="text-2xl md:text-3xl font-extrabold text-white mb-4 leading-tight max-w-md" data-id="element-228">
          {t('lang.headline')}
        </h1>
        <p className="text-white/50 font-body text-sm" data-id="element-229">{t('hook.subtitle')}</p>
      </div>

      <button onClick={onStart} className="w-full max-w-xs bg-solventum-primary hover:bg-[#04c444] text-solventum-bg font-headline font-extrabold py-4 px-6 rounded-xl transition-colors duration-200 text-lg shadow-[0_0_15px_rgba(5,221,77,0.2)]" data-id="element-230">
        {t('hook.start')}
      </button>
    </div>;
}